export const STOREFRONT_FOUNDATION_SETTING = "storefront_merchandising_v2";

const enabledValues = new Set([true, 1, "1", "true", "enabled", "on"]);

const normalizeFlagValue = (value) =>
  typeof value === "string" ? value.toLowerCase() : value;

export const isStorefrontMerchandisingEligible = (settings = {}) =>
  !enabledValues.has(normalizeFlagValue(settings?.is_b2b)) &&
  !enabledValues.has(normalizeFlagValue(settings?.enable_b2b_storefront));

export const isStorefrontFoundationEnabled = (settings = {}) => {
  const safeSettings = settings || {};
  if (!isStorefrontMerchandisingEligible(safeSettings)) return false;
  return enabledValues.has(
    normalizeFlagValue(safeSettings[STOREFRONT_FOUNDATION_SETTING]),
  );
};

// Only shopper browse routes: account, tracking, checkout and distributor pages
// retain their own independently gated layouts.
export const isStorefrontBrowseEnabled = (settings, pathname = "/", isB2B = false) =>
  !isB2B && isStorefrontFoundationEnabled(settings) &&
  (pathname === "/" || /^\/(product|category|search)(\/|$)/.test(pathname));

export const isStorefrontGridEnabled = (settings = {}) =>
  isStorefrontFoundationEnabled(settings) &&
  ["grid", "grid2"].includes(settings?.store_layout);
